import { Col, Form, Input } from 'antd';
import type { IField } from '../data';

const { Item } = Form;

const Search: React.FC<IField> = (props) => {
    const {
        name,
        span = 8,
        label,
        enterButton = true,
        placeholder,
        suffix = false,
        xs,
        lg,
        marginBottom = 0,
        style,
        prefix,
        onSearch,
        rules,
        disabled,
        suffixWidth,
        hidden,
        onChange,
        onKeyUp,
        t,
    } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    const typeOfLabel = typeof label;

    return (
        <Col key={name} {...grid}>
            <Item hidden={hidden} label={typeOfLabel === 'object' ? label : t?.(label)} {...styling}>
                <Item noStyle name={name} rules={rules}>
                    <Input.Search
                        disabled={disabled}
                        placeholder={t?.(placeholder)}
                        onSearch={onSearch}
                        enterButton={enterButton}
                        style={suffix ? { width: `calc(100% - ${suffixWidth}px)` } : style}
                        prefix={prefix}
                        suffix={suffix && suffix}
                        onChange={onChange}
                        onKeyUp={onKeyUp}
                    />
                </Item>
            </Item>
        </Col>
    );
};

export default Search;
